<template>
  <div @click="addOrRemoveFromFavorites()" class="casino-favorites-container">
    <span v-if="!localFavorite" class="casino-favorites-icon-empty"></span>
    <span v-if="localFavorite" class="casino-favorites-icon-full"></span>
  </div>
</template>
<script>
import store from '@/store'
import Casino from '@/components/mixins/Casino'

export default {
  name: 'casinoFavorites',
  props: ['favorite', 'gameId'],
  mixins: [Casino],
  data () {
    return {
      localFavorite: this.favorite
    }
  },
  computed: {},
  methods: {
    addOrRemoveFromFavorites () {
      let action = this.favorite ? 'removeFromFavorite' : 'addToFavorite'
      store.dispatch(`gap/${action}`, this.gameId)
    }
  },
  mounted () {},
  watch: {
    favorite (newVal) {
      this.localFavorite = newVal
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoFavorites.vue